import { gql } from "@apollo/client";

export const GET_LEGAL_REPRESENTATIVE = gql`
  query GetLegalRepresentative(
    $establishmentId: String!
    $legalRepresentativeId: String!
  ) {
    QR_GET_LEGAL_REPRESENTATIVE(
      establishmentId: $establishmentId
      legalRepresentativeId: $legalRepresentativeId
    ) {
      code
      data {
        id
        lastName
        firstName
        identityDocumentType
        identityNumber
        identityExpiryDate
        supportingDocumentsId
        email
        phoneNumber {
          indicative
          number
        }
        ownershipPercentage
        nationality
      }
    }
  }
`;

export const ADD_LEGAL_REPRESENTATIVE_MUTATION = gql`
  mutation AddLegalRepresentative(
    $establishmentId: String!
    $legalRepresentativeInput: LegalRepresentativeInput!
  ) {
    MT_ADD_LEGAL_REPRESENTATIVE(
      establishmentId: $establishmentId
      legalRepresentativeInput: $legalRepresentativeInput
    ) {
      code
      data {
        id
      }
    }
  }
`;

export const UPDATE_LEGAL_REPRESENTATIVE_MUTATION = gql`
  mutation UpdateLegalRepresentative(
    $establishmentId: String!
    $legalRepresentativeId: String!
    $legalRepresentativeInput: LegalRepresentativeInput!
  ) {
    MT_UPDATE_LEGAL_REPRESENTATIVE(
      establishmentId: $establishmentId
      legalRepresentativeId: $legalRepresentativeId
      legalRepresentativeInput: $legalRepresentativeInput
    ) {
      code
      data {
        id
      }
    }
  }
`;
